import { Injectable } from '@angular/core';
import { IEntity, INamedEntity } from 'interfaces-lib';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EntityControllerService {
  private entitySelectedSubject = new BehaviorSubject<IEntity | INamedEntity | undefined>(undefined);
  entitySelected$ = this.entitySelectedSubject.asObservable();
  entity: IEntity | INamedEntity | undefined = undefined;

  constructor() {}

  entitySelected(entity: IEntity | INamedEntity): void {
    this.entity = entity;
    this.entitySelectedSubject.next(entity);
  }
}
